const eventKinds = {
  calendarMoved: 'calendarMoved',
  tasksListInit: 'tasksListInit',
  calendarTaskUpdated: 'calendarTaskUpdated',
  calendarShown: 'calendarShown',
  tasksListShown: 'tasksListShown',
  storehouseShown: 'storehouseShown',
  driverListingShown: 'driverListingShown',
  placesShown: 'placesShown',
  reportsShown: 'reportsShown',
  usersShown: 'usersShown',
  vehiclesFilterShown: 'vehiclesFilterShown',
  driverAttached: 'driverAttached',
  driverCommentAdded: 'driverCommentAdded',
  driverCommentDeleted: 'driverCommentDeleted',
  driverColorChanged: 'driverColorChanged',
  trailerCommentAdded: 'trailerCommentAdded',
  trailerCommentDeleted: 'trailerCommentDeleted',
  vehicleCommentAdded: 'vehicleCommentAdded',
  vehicleCommentDeleted: 'vehicleCommentDeleted',
  vehiclesPolled: 'vehiclesPolled',
  vehicleCommentModalRequested: 'vehicleCommentModalRequested',
  trailerCommentModalRequested: 'trailerCommentModalRequested',
  driverCommentModalRequested: 'driverCommentModalRequested',
  selectTrailerParkingModalRequested: 'selectTrailerParkingModalRequested',
  trailerAttached: 'trailerAttached',
  rangePlanCommentModalRequested: 'randgePlanCommentModalRequested',
  taskCopyModalRequested: 'taskCopyModalRequested',
  taskCopied: 'taskCopied',
  planningSearchClosed: 'planningSearchClosed',
  vignetteAdded: 'vignetteAdded'
}

export default eventKinds
